@if (visible()) {
    <button
        class="se-ui-datagrid-button_box se-button-no-ripple"
        [class.delete_button]="activeClass()"
        mat-icon-button
        [disableRipple]="true"
        (click)="onButtonClick($event)"
        title="{{ tooltip() | translate }}"
    >
        <mat-icon>{{ icon() }}</mat-icon>
    </button>
}
